import { render, staticRenderFns } from "./guard_witness_list.vue?vue&type=template&id=01f51a27&scoped=true"
import script from "./guard_witness_list.vue?vue&type=script&lang=js"
export * from "./guard_witness_list.vue?vue&type=script&lang=js"
import style0 from "./guard_witness_list.vue?vue&type=style&index=0&id=01f51a27&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f51a27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f51a27')) {
      api.createRecord('01f51a27', component.options)
    } else {
      api.reload('01f51a27', component.options)
    }
    module.hot.accept("./guard_witness_list.vue?vue&type=template&id=01f51a27&scoped=true", function () {
      api.rerender('01f51a27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/guardWitness/guard_witness_list.vue"
export default component.exports